import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h3>
         This site is created by Abdulaziz Toshpo'latov Abdulatif o'g'li
      </h3>
    </div>
  );
};

export default Footer;
